// extracted by mini-css-extract-plugin
export default {"survey":"event_survey__Gwt1M","titleHeader":"event_titleHeader__dm-ZS","title":"event_title__450N3"};